import { IconProps } from './icon';

export const getIcon = (props: IconProps) => {
  const {
    'data-cy': dataCy,
    'data-testid': dataTestid,
    classNames,
    height,
    width,
    name,
    title,
  } = props;

  const dataCyAttribute = `${dataCy}-icon`;
  const dataTestidAttribute = `${dataTestid}-icon`;

  switch (name) {
    case 'icon-arrow-back':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 24 24"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path d="M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z"></path>
        </svg>
      );
    case 'icon-arrow-forward':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 24 24"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path d="m12 4-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z"></path>
        </svg>
      );
    case 'icon-chevron-left':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 24 24"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path d="M11.67 3.87 9.9 2.1 0 12l9.9 9.9 1.77-1.77L3.54 12z"></path>
        </svg>
      );
    case 'icon-close':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 24 24"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
        </svg>
      );
    case 'icon-question-mark':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 24 24"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            d="M8 15.1668c3.6819 0 6.6667-2.9847 6.6667-6.6666 0-3.682-2.9848-6.6667-6.6667-6.6667-3.6819 0-6.6667 2.9848-6.6667 6.6667 0 3.6819 2.9848 6.6666 6.6667 6.6666Z"
            stroke="#000"
            strokeWidth="1.3333"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
          <path
            d="M6.06 6.4999a2 2 0 0 1 3.8867.6667c0 1.3333-2 2-2 2M8 11.8335h.0067"
            stroke="#000"
            strokeWidth="1.3333"
            strokeLinecap="round"
            strokeLinejoin="round"
            fill="none"
          />
        </svg>
      );
    case 'icon-quickdetails-doors':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 32 32"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fillRule="evenodd"
            d="M26.91 26.97H4.03V14.78l9.63-9.75h12.05c.66 0 1.2.54 1.2 1.22v20.72Zm-3.61-8.53h-3.62v2.44h3.62v-2.44ZM7.44 14.78l7.22-7.31h9.84v7.31H7.44Z"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'icon-quickdetails-engine':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 32 32"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fill="#212121"
            d="M11 7v2h3v2h-3l-2 2v3H7v-3H5v8h2v-3h2v3h3l2 2h8v-4h2v3h3V12h-3v3h-2v-4h-6V9h3V7h-8Z"
          />
        </svg>
      );
    case 'icon-quickdetails-fuel':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 32 32"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fillRule="evenodd"
            d="M24.36 9.84h1.2c.68 0 1.22.54 1.22 1.2v11.5a3.02 3.02 0 1 1-6.05 0v-4.23c0-.67-.54-1.21-1.21-1.21v7.26a2.42 2.42 0 0 1-2.42 2.42H7.42A2.42 2.42 0 0 1 5 24.36V7.42A2.42 2.42 0 0 1 7.42 5h9.68a2.42 2.42 0 0 1 2.42 2.42v7.26c2 0 3.63 1.62 3.63 3.63v4.23a.6.6 0 0 0 1.2 0V12.26a2.42 2.42 0 0 1-2.41-2.42V6.21a1.21 1.21 0 1 1 2.42 0v3.63Zm-7.6 4.47c.23-.22.35-.53.34-.84V9.84c0-.67-.54-1.21-1.21-1.21H8.63c-.67 0-1.21.54-1.21 1.21v3.63a1.23 1.23 0 0 0 1.26 1.2h7.26c.31 0 .61-.13.83-.36Z"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'icon-quickdetails-seats':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 32 32"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fillRule="evenodd"
            d="M8 9.34c0 4.34 3.17 13.02 3.17 13.02s3.17-2.17 3.17-5.43c0-1.79-.96-3.25-1.83-4.57-.7-1.07-1.34-2.04-1.34-3.02 0-1.27.36-1.8.66-2.23.21-.31.4-.58.4-1.03C12.23 5 11.17 5 11.17 5H10.1S8 5 8 9.34Zm4.23 14.65s3.17-2.72 4.22-2.72v.11h5.28c1.17 0 2.12.98 2.12 2.17v1.09c0 1.19-.95 2.17-2.12 2.17H15.4c-2.12 0-3.17-1.96-3.17-1.96-.22-.32-.32-.65 0-.86Z"
            clipRule="evenodd"
          />
        </svg>
      );
    case 'icon-quickdetails-range':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 32 32"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path d="M13.7065 19.2506H18.2932C18.7457 19.2506 19.1125 18.8424 19.1125 18.3388V8.25943C19.1125 7.7555 18.7457 7.34729 18.2932 7.34729H17.4071V6.38063C17.4073 6.33063 17.3971 6.28111 17.3773 6.23489C17.3575 6.18868 17.3284 6.14668 17.2917 6.11131C17.255 6.07595 17.2114 6.04791 17.1634 6.02881C17.1154 6.0097 17.0639 5.99991 17.012 6H14.9988C14.7803 6 14.603 6.17003 14.603 6.38063V7.34729H13.7065C13.254 7.34729 12.8872 7.7555 12.8872 8.25943V18.3391C12.8872 18.8427 13.254 19.2506 13.7065 19.2506ZM15.5909 10.4517H17.3566L16.2493 12.4879L17.6293 12.4901L14.6748 16.2831C14.6276 16.335 14.5366 16.2893 14.5598 16.226L15.5396 13.6291L14.3707 13.5765L15.5909 10.4517ZM22.069 21.6194H6.89687V24.5398H22.069V26L25.1035 23.0796L22.069 20.1592V21.6194ZM10.6967 16.9156H11.8757V8.37138H7.74719C7.17199 8.3928 6.7846 8.69847 6.38506 9.03626C5.99227 9.38542 5.61668 9.82088 5.27817 10.2521C4.60284 11.1143 4.08598 11.9573 4.0789 11.9677C4.02664 12.0531 4.00169 12.1462 4 12.2383V16.3698C4 16.5132 4.06136 16.6543 4.16689 16.7556C4.27242 16.8568 4.41943 16.9152 4.56879 16.9152H5.37021C5.45103 17.5402 5.76629 18.1152 6.25671 18.5321C6.74714 18.949 7.37893 19.1791 8.03329 19.1792C8.68764 19.1792 9.31946 18.9492 9.80994 18.5323C10.3004 18.1154 10.6158 17.5405 10.6967 16.9156ZM6.48486 16.6073C6.48558 16.2123 6.64897 15.8336 6.93924 15.5543C7.22951 15.275 7.62298 15.1178 8.03343 15.1172C8.44395 15.1177 8.83751 15.2749 9.12785 15.5542C9.41819 15.8335 9.58163 16.2122 9.58234 16.6073C9.58136 17.0022 9.41781 17.3807 9.12749 17.6598C8.83718 17.9389 8.44378 18.0959 8.03343 18.0964C7.62315 18.0958 7.22983 17.9387 6.93959 17.6596C6.64935 17.3806 6.48584 17.0022 6.48486 16.6073ZM27.8854 14.5224C27.7785 14.0935 27.6534 13.6142 27.1123 13.3215C25.499 12.5508 22.889 11.7474 22.889 11.7474L20.1243 9.67583V16.9156H21.2224C21.3008 17.5422 21.6149 18.1196 22.1054 18.5387C22.5958 18.9577 23.2288 19.1894 23.8846 19.1899C25.2592 19.1899 26.3897 18.1963 26.5482 16.9156H27.411C27.5536 16.9158 27.6911 16.8643 27.796 16.7712C27.9009 16.6782 27.9654 16.5504 27.9767 16.4136C27.9929 16.2057 28.0008 15.9973 28.0003 15.7889C27.999 15.4274 27.9794 14.9647 27.8854 14.5224ZM23.8843 18.0964C23.0299 18.0951 22.3388 17.4295 22.3371 16.607C22.3388 15.7841 23.0299 15.1185 23.8843 15.1172C24.2948 15.1177 24.6883 15.2748 24.9786 15.5541C25.2689 15.8333 25.4324 16.2119 25.4332 16.607C25.4323 17.0019 25.2688 17.3805 24.9785 17.6596C24.6882 17.9388 24.2947 18.0959 23.8843 18.0964Z" />
        </svg>
      );
    case 'icon-quickdetails-transmission':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 32 32"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path d="M26.14 9.58V16c0 .4-.14.76-.43 1.05-.29.3-.64.45-1.06.45h-7.5v4.92c.46.27.82.63 1.1 1.08.27.45.4.95.4 1.5 0 .83-.3 1.54-.88 2.12-.58.59-1.29.88-2.12.88-.82 0-1.53-.3-2.11-.88a2.9 2.9 0 0 1-.88-2.12c0-.55.13-1.05.4-1.5.28-.45.64-.81 1.1-1.08V17.5h-6v4.92c.45.27.82.63 1.1 1.08.26.45.4.95.4 1.5 0 .83-.3 1.54-.88 2.12-.58.59-1.29.88-2.12.88-.82 0-1.53-.3-2.12-.88A2.9 2.9 0 0 1 3.67 25c0-.55.13-1.05.4-1.5.28-.45.64-.81 1.1-1.08V9.58a3.06 3.06 0 0 1-1.1-1.08 2.85 2.85 0 0 1-.4-1.5c0-.83.29-1.54.87-2.12.59-.59 1.3-.88 2.12-.88.83 0 1.54.3 2.12.88.59.58.88 1.3.88 2.12 0 .55-.14 1.05-.4 1.5-.28.45-.65.81-1.1 1.08v4.92h6V9.58a3.06 3.06 0 0 1-1.1-1.08 2.85 2.85 0 0 1-.4-1.5c0-.83.29-1.54.88-2.12.58-.59 1.29-.88 2.11-.88.83 0 1.54.3 2.12.88.59.58.88 1.3.88 2.12 0 .55-.13 1.05-.4 1.5-.28.45-.64.81-1.1 1.08v4.92h6V9.58a3.06 3.06 0 0 1-1.1-1.08 2.85 2.85 0 0 1-.4-1.5c0-.83.3-1.54.88-2.12.58-.59 1.29-.88 2.12-.88.82 0 1.53.3 2.12.88.58.58.87 1.3.87 2.12 0 .55-.13 1.05-.4 1.5-.28.45-.64.81-1.1 1.08Z" />
        </svg>
      );
    case 'bolt':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height="32px"
          viewBox="0 0 32 32"
          width="32px"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.271 6.075c.37.16.59.546.54.947l-.781 6.25h7.152a.91.91 0 0 1 .698 1.492l-9.09 10.909a.91.91 0 0 1-1.601-.695l.781-6.25H7.818a.91.91 0 0 1-.698-1.492l9.09-10.909a.91.91 0 0 1 1.061-.252ZM9.76 16.91H16a.91.91 0 0 1 .902 1.022l-.524 4.196 5.863-7.036H16a.909.909 0 0 1-.902-1.022l.524-4.196L9.76 16.91Z"
            fill="#000"
          />
        </svg>
      );
    case 'users':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height="32px"
          viewBox="0 0 32 32"
          width="32px"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.464 7.464a5 5 0 1 1 7.071 7.071 5 5 0 0 1-7.07-7.07ZM13 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm6.031-1.118a1 1 0 0 1 1.217-.72 5 5 0 0 1 0 9.687 1 1 0 0 1-.496-1.938 3 3 0 0 0 0-5.812 1 1 0 0 1-.72-1.217ZM5.464 19.465A5 5 0 0 1 9 18h8a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 1.464-3.535Zm17.568-.585a1 1 0 0 1 1.218-.718A5 5 0 0 1 28 22.999V25a1 1 0 1 1-2 0v-2a3 3 0 0 0-2.25-2.902 1 1 0 0 1-.718-1.218Z"
            fill="#000"
          />
        </svg>
      );
    case 'user-check':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          data-testid={dataTestidAttribute}
          focusable="false"
          height="32px"
          viewBox="0 0 32 32"
          width="32px"
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.964 7.464a5 5 0 1 1 7.071 7.071 5 5 0 0 1-7.07-7.07ZM12.5 8a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm15.207 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L23 15.586l3.293-3.293a1 1 0 0 1 1.414 0ZM5.464 19.465A5 5 0 0 1 9 18h7a5 5 0 0 1 5 5v2a1 1 0 1 1-2 0v-2a3 3 0 0 0-3-3H9a3 3 0 0 0-3 3v2a1 1 0 1 1-2 0v-2a5 5 0 0 1 1.464-3.535Z"
            fill="#000"
          />
        </svg>
      );
    case 'close-circle':
      return (
        <svg
          className={classNames}
          aria-hidden="true"
          data-cy={dataCyAttribute}
          focusable="false"
          height={height}
          viewBox="0 0 18 19"
          width={width}
          xmlns="http://www.w3.org/2000/svg"
        >
          {title && <title>{title}</title>}
          <path
            d="M9 16.5C13.1421 16.5 16.5 13.1421 16.5 9C16.5 4.85786 13.1421 1.5 9 1.5C4.85786 1.5 1.5 4.85786 1.5 9C1.5 13.1421 4.85786 16.5 9 16.5Z"
            stroke="#CF3535"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M11.25 6.75L6.75 11.25"
            stroke="#CF3535"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.75 6.75L11.25 11.25"
            stroke="#CF3535"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      );
    case 'tick-circle':
      return (
        <svg
          width="24"
          height="25"
          viewBox="0 0 24 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M11.4281 16.4284C10.9172 16.9393 10.0828 16.9393 9.57187 16.4284L6.57187 13.4284C6.06094 12.9174 6.06094 12.0831 6.57187 11.5721C7.08281 11.0612 7.91719 11.0612 8.42813 11.5721L10.5 13.644L15.5719 8.57212C16.0828 8.06118 16.9172 8.06118 17.4281 8.57212C17.9391 9.08306 17.9391 9.91743 17.4281 10.4284L11.4281 16.4284ZM24 12.5002C24 19.1284 18.6281 24.5002 12 24.5002C5.37188 24.5002 0 19.1284 0 12.5002C0 5.87212 5.37188 0.500244 12 0.500244C18.6281 0.500244 24 5.87212 24 12.5002ZM12 2.75024C6.61406 2.75024 2.25 7.11431 2.25 12.5002C2.25 17.8862 6.61406 22.2502 12 22.2502C17.3859 22.2502 21.75 17.8862 21.75 12.5002C21.75 7.11431 17.3859 2.75024 12 2.75024Z"
            fill="black"
          />
        </svg>
      );
  }
};
